//user
export const USER_ROLES = { admin: "admin", salesManager: "salesManager", salesman: "salesman" };

//comments on user
export const COMMENT_TYPES = { sales: "sales", communications: "communications", assignments: "assignments" };
export const COMMENT_LABEL_TYPES = { important: "important", noLabel: "" };
export const USER_COMMENT_COLORS = { important: { bg: "#f899ab8c" } };
export const COMMENT_UPDATE_ACTION_TYPES = { SALES: "SALES", ASSIGNMENTS: "ASSIGNMENTS" };
//tags on user
export const TAG_TYPES = { commentTags: "commentTags", assignmentTags: "assignmentTags" };

export const INITIAL_NEW_ASSIGNMENT_TIME = "01:00";
export const INITIAL_SELECTED_FILTER_KEY_TAG = "all";

//pending user
export const PENDING_USER_ACTION_TYPES = {
  reject: "reject",
  new: "new",
  existing: "existing",
  attachExistingCard: "attachExistingCard",
  back: "back"
};

export const PENDING_USER_TYPES = {
  btaxRegister: "btaxRegister",
  expiredBtaxSub: "expiredBtaxSub",
  bquickRegister: "bquickRegister",
  expiredBquickSub: "expiredBquickSub"
};

//user search
//fields needed to send a search by types query (the fields' data is from the state)
export const USER_SEARCH_BY_TYPE_STATE_FIELDS = [
  "searchTypes",
  "searchCompany",
  "searchClientNotBelongToAnybody",
  "searchClientBelongToSpecific",
  "clientOwner",
  "amountOfUsersToReturn",
  "clientJobTitle",
  "searchActivityStatuses",
  "searchValidityStatuses",
  "membershipExpiryStartDate",
  "membershipExpiryEndDate"
];

//member search
//possible activity states for a member for the search table
export const MEMBER_ACTIVITY_STATES = {
  suspended: { title: "מושהה", field: "suspended" },
  active: { title: "פעיל", field: "active" }
};
export const MEMBER_VALIDITY_STATES = { valid: "valid", expired: "expired" };

//product and courses
export const PRODUCT_TYPES = { btax: "btax", bquick: "bquick", courses: "courses" };
export const COURSE_TYPES = { silver: "silver", gold: "gold", platinum: "platinum" };

//excel download
export const EXCEL_DOWNLOAD_STATE_FIELDS = [...USER_SEARCH_BY_TYPE_STATE_FIELDS, "excelType"];
export const VALID_EXCEL_TYPES = { fullExcel: "fullExcel", smooveExcel: "smooveExcel" };
